export default "__VITE_ASSET__CgIfO3rZ__"